export class CreateReverseAudit
{
    constructor(){
        this.PropertyIDs=[];
        this.SearchPoints=[];
    }
    AuditID:string;
    AuditRvrID:string;
    CustomerID:number;
    CustomerAccountName:string;
    CustomerAccountID:string;
    Priority:string;
    ScheduledRunDate:Date;
    SendNotifications:boolean;
    NotificationTemplateID:string;
    AuditContactEmailAddress:string;
    PropertyIDs:string[];
    DateChecked:string;
    SearchPoints:CreateReverseAudit_SearchPoint[];
    IncludeExcludeChainCodes:string;

    AuditAmadeus:boolean;
    AuditApollo:boolean;
    AuditGalileo:boolean;
    AuditSabre:boolean;
    AuditWorldspan:boolean;
    AmadeusRAC:string;
    ApolloRAC:string;
    GalileoRAC:string;
    SabreRAC:string;
    WorldspanRAC:string;
    RACFilters:string;
    SabrePCC:string;

}

export class CreateReverseAudit_SearchPoint{
  Type:number;
  Name:string;
  PropertyAddress:string;
  Latitude:number;
  Longitude:number;
  Radiuskm:number;
  Radius?:number;
}

export class Property
{
    IsChecked:boolean;
    AuditPropertyID:string;
    AuditID:string;
    PropertyName:string
    PropertyAddress:string;
    PropertyCity:string;
    PropertyStateProvince:string;
    PropertyPostalCode:string;
    PropertyCountry:string;
    PropertyContactPhone:string;
    PropertyContactName:string;
    PropertyContactEMail:string;
    AmadeusChainCode:string;
    AmadeusPropCode:string;
    AmadeusRAC:string;
    ApolloChainCode:string;
    ApolloPropCode:string;
    ApolloRAC:string;
    CurrencyCode:string;
    LRA:boolean;
    GalileoChainCode:string;
    GalileoPropCode:string;
    GalileoRAC:string;
    SabreChainCode:string;
    SabrePropCode:string;
    SabreRAC:string;
    Season1End:Date;
    Season1ExpectedPrice:number;
    Season1Start:Date;
    WorldspanChainCode:string;
    WorldspanPropCode:string;
    WorldspanRAC:string;
}
